import { useEffect, useState } from "react";
import { TimeSlot } from "../core/types/types";
import { apiService } from "../core/services/apiService";

export const useTimeSlots = (eventID: number) => {
  const [timeSlots, setTimeSlots] = useState<TimeSlot[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await apiService.getTimeSlots(eventID);

        if (response?.status === 200) {
          const data: TimeSlot[] = response.data;
          setTimeSlots(data);
        } else {
          setError("Failed to load time slots.");
        }
      } catch (e) {
        console.error("Fetch error:", e);
        setError("An error occurred while fetching data.");
      } finally {
        setIsLoading(false);
      }
    };

    // Skip fetching if eventID is 0
    if (eventID === 0) {
      setTimeSlots([]);
      setIsLoading(false);
    } else {
      fetchTimeSlots();
    }
  }, [eventID]);

  return { timeSlots, isLoading, error };
};
